import React from 'react';
import { 
  Grid, 
  Typography, 
  Box,
  Paper, 
  Avatar,
  Divider,
  Chip
} from '@mui/material';

// Sample bar menu items
const drinkItems = [
  {
    name: "Interstellar Martini",
    description: "Vodka, blue curaçao, white cranberry juice, and a touch of edible shimmer dust for a galaxy-inspired look.",
    price: "$12",
    category: "Signature Cocktails"
  },
  {
    name: "Director's Old Fashioned",
    description: "Premium bourbon, house-made bitters, brown sugar syrup, and an orange peel, served with a large ice sphere.",
    price: "$14",
    category: "Signature Cocktails"
  },
  {
    name: "Blockbuster Mule",
    description: "Our twist on the Moscow Mule with vodka, fresh lime, house-made ginger syrup, and soda water, served in a copper mug.",
    price: "$13",
    category: "Signature Cocktails"
  },
  {
    name: "Silver Screen Margarita",
    description: "Silver tequila, fresh lime juice, agave nectar, and a black salt rim for a dramatic presentation.",
    price: "$13",
    category: "Signature Cocktails"
  },
  {
    name: "Cinema Rouge",
    description: "Cabernet Sauvignon with notes of blackcurrant and cedar. Pairs well with our red meat dishes.",
    price: "$11 glass / $38 bottle",
    category: "Wines"
  },
  {
    name: "Spotlight Craft IPA",
    description: "Local IPA with citrus and pine notes, brewed exclusively for Stellar Cinemas.",
    price: "$8",
    category: "Beers"
  }
];

const BarMenu = () => {
  return (
    <Box>
      <Grid container spacing={4}>
        {drinkItems.map((drink, index) => (
          <Grid 
            item 
            xs={12} 
            sm={6} 
            key={index}
            sx={{
              animation: `fadeIn ${0.3 + index * 0.1}s ease-out`,
              '@keyframes fadeIn': {
                '0%': { opacity: 0, transform: 'translateY(20px)' },
                '100%': { opacity: 1, transform: 'translateY(0)' }
              }
            }}
          >
            <Paper 
              elevation={2}
              sx={{ 
                p: 2,
                display: 'flex',
                borderRadius: 3,
                overflow: 'hidden',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-5px)',
                  boxShadow: '0 12px 25px rgba(0,0,0,0.15)',
                  '& .drink-avatar': {
                    transform: 'scale(1.05)'
                  }
                }
              }}
            >
              <Box sx={{ flexGrow: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                  <Typography variant="h6" component="h3" sx={{ fontWeight: 700 }}>
                    {drink.name}
                  </Typography>
                  <Chip 
                    label={drink.price} 
                    color="secondary" 
                    size="small"
                    sx={{ fontWeight: 600 }}
                  />
                </Box>
                <Divider sx={{ my: 1 }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Chip 
                    label={drink.category} 
                    variant="outlined" 
                    size="small" 
                    sx={{ height: 20, fontSize: '0.7rem' }}
                  />
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {drink.description}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default BarMenu; 